import { MinzeElement, Attrs } from 'minze'

export interface LvcCloseIcon {
  width?: number
  height?: number
}

export class LvcCloseIcon extends MinzeElement {
  attrs: Attrs = [
    ['width', 28],
    ['height', 28],
  ]
  html = () => `
    <svg width="${this.width ?? '28'}" height="${this.height ?? '28'}" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M23.8002 23.8C20.2228 20.7919 16.778 17.625 13.4771 14.3106M13.4771 14.3106C10.2697 11.0901 7.12548 7.68879 4.2002 4.19996M13.4771 14.3106C16.5105 10.6956 20.1075 7.67808 23.8002 4.19995M13.4771 14.3106C9.99119 18.0175 7.43695 20.1909 4.2002 23.8" stroke="#1E007D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `

  css = () => `
    :host {
      width: ${this.width ?? '28'}px;
      height: ${this.height ?? '28'}px;
    }
  `
}
